import { formatDistance } from "./mk/_lib/formatDistance.js";
import { formatLong } from "./mk/_lib/formatLong.js";
import { formatRelative } from "./mk/_lib/formatRelative.js";
import { localize } from "./mk/_lib/localize.js";
import { match } from "./mk/_lib/match.js";

/**
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar](https://github.com/vlahupetar)
 * @author Altrim Beqiri [@altrim](https://github.com/altrim)
 */
export const mk = {
  code: "mk",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
};

// Fallback for modularized imports:
export default mk;
